module.exports = __webpack_public_path__ + "static/media/authorize-dot-net.448dcf56.png";